import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./App";
import { UserDataProvider } from "./context/UserDataContext"; // Import UserDataProvider
import AuthProvider from "./context/AuthContext";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <UserDataProvider>
        <AuthProvider>
          <App /> 
        </AuthProvider>
      </UserDataProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
